export default function formatInteger(value: number | null | undefined): string {
  if (value || value === 0) {
    return value.toString();
  }
  return "";
}
